"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Keys = {
	backspace: 8,
	tab: 9,
	enter: 13,
	shift: 16,
	ctrl: 17,
	alt: 18,
	pause_break: 19,
	caps_lock: 20,
	escape: 27,
	space: 32,
	page_up: 33,
	page_down: 34,
	end: 35,
	home: 36,
	left_arrow: 37,
	up_arrow: 38,
	right_arrow: 39,
	down_arrow: 40,
	insert: 45,
	delete: 46,
	0: 48,
	1: 49,
	2: 50,
	3: 51,
	4: 52,
	5: 53,
	6: 54,
	7: 55,
	8: 56,
	9: 57,
	a: 65,
	b: 66,
	c: 67,
	d: 68,
	e: 69,
	f: 70,
	g: 71,
	h: 72,
	i: 73,
	j: 74,
	k: 75,
	l: 76,
	m: 77,
	n: 78,
	o: 79,
	p: 80,
	q: 81,
	r: 82,
	s: 83,
	t: 84,
	u: 85,
	v: 86,
	w: 87,
	x: 88,
	y: 89,
	z: 90,
	left_window_key: 91,
	right_window_key: 92,
	select_key: 93,
	numpad_0: 96,
	numpad_1: 97,
	numpad_2: 98,
	numpad_3: 99,
	numpad_4: 100,
	numpad_5: 101,
	numpad_6: 102,
	numpad_7: 103,
	numpad_8: 104,
	numpad_9: 105,
	multiply: 106,
	add: 107,
	subtract: 109,
	decimal_point: 110,
	divide: 111,
	f1: 112,
	f2: 113,
	f3: 114,
	f4: 115,
	f5: 116,
	f6: 117,
	f7: 118,
	f8: 119,
	f9: 120,
	f10: 121,
	f11: 122,
	f12: 123,
	f13: 124,
	f14: 125,
	f15: 126,
	f16: 127,
	f17: 128,
	f18: 129,
	f19: 130,
	num_lock: 144,
	scroll_lock: 145,
	semi_colon: 186,
	equal_sign: 187,
	comma: 188,
	dash: 189,
	period: 190,
	forward_slash: 191,
	grave_accent: 192,
	open_bracket: 219,
	back_slash: 220,
	close_bracket: 221,
	single_quote: 222
};

var Buttons = {
	left: 0,
	middle: 1,
	right: 2
};

/**
 *  A wrapper for checking keypresses
 * cb will be called only when any ofthe speficied keys are pressed
 * @param {object} e event object
 * @param {array} key codes to match
 * @param {function} cb callback
 */
var OnKey = function OnKey(e) {
	var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var cb = arguments[2];

	if (cb && keys.includes(e.which)) {
		cb(e);
	}
};

/**
 *  A wrapper for checking selection keypresses
 * cb will be called only when enter or space are pressed
 * @param {object} e event object
 * @param {function} cb callback
 */
var OnActionKey = function OnActionKey(e, cb) {
	OnKey(e, [Keys.space, Keys.enter], cb);
};

/**
 *  A wrapper for checking mouse clicks
 * cb will be called only when any of the specified mouse buttons are clicked
 * @param {object} e event object
 * @param {array} key codes to match
 * @param {function} cb callback
 */
var OnButton = function OnButton(e) {
	var buttons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var cb = arguments[2];

	if (cb && buttons.includes(e.button)) {
		cb(e);
	}
};

/**
 *  A wrapper for checking selection click
 * cb will be called only when left mouse button is clicked
 * @param {object} e event object
 * @param {function} cb callback
 */
var OnActionMouse = function OnActionMouse(e, cb) {
	OnButton(e, [Buttons.left], cb);
};

exports.OnActionKey = OnActionKey;
exports.OnActionMouse = OnActionMouse;
exports.OnKey = OnKey;
exports.Keys = Keys;
exports.Buttons = Buttons;
var _default = { OnActionKey: OnActionKey, OnActionMouse: OnActionMouse, OnKey: OnKey, Keys: Keys, Buttons: Buttons };
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Keys, "Keys", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(Buttons, "Buttons", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(OnKey, "OnKey", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(OnActionKey, "OnActionKey", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(OnButton, "OnButton", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(OnActionMouse, "OnActionMouse", "src/components/accessibilityUtils.js");

	__REACT_HOT_LOADER__.register(_default, "default", "src/components/accessibilityUtils.js");
}();

;